import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_VOUCHER_FOLLOWUP_FAILURE,
  GET_VOUCHER_FOLLOWUP_REQUEST,
  GET_VOUCHER_FOLLOWUP_SUCCESS,
} from './eaDashboard.types';

// Get voucher follow-up data (vouchers awaiting action on the selected user's files)
export const getVoucherFollowUp = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_VOUCHER_FOLLOWUP_REQUEST, GET_VOUCHER_FOLLOWUP_SUCCESS, GET_VOUCHER_FOLLOWUP_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/followup/${userId}`,
    method: 'GET',
  },
});
